<p>
  reset works!
</p>
